<p>
  reset works!
</p>
